import type {Property} from "@/src/modules/properties/types";
import type {Household} from "@/src/modules/households/types";

import {
  getSafelistingHouseholdAddressLine,
  getSafelistingPropertySummary,
} from "../lib/safelisting-household-display";

type SafelistingHouseholdDetailProps = {
  household: Household | null | undefined;
  property?: Pick<
    Property,
    "name" | "number" | "street" | "unit_number" | "city" | "state" | "zipcode" | "country"
  > | null;
};

/** Address + property summary (resident-home style, no PIN / share). */
export function SafelistingHouseholdDetail({
  household,
  property,
}: SafelistingHouseholdDetailProps) {
  const address = getSafelistingHouseholdAddressLine(household);
  const propertySummary = getSafelistingPropertySummary(property);

  if (!address && !propertySummary) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className="flex min-w-0 flex-col gap-0">
      {address ? <p className="text-pretty leading-snug">{address}</p> : null}
      {propertySummary ? (
        <p className="text-muted-foreground text-pretty leading-snug">{propertySummary}</p>
      ) : null}
    </div>
  );
}
